import { GeneralInformation } from '../interfaces/general-information';
import { getFouls } from './get-fouls';
import { getMappedGameInfo } from './get-mapped-game-info';
import { getScore } from './get-score';

export async function getData(matchId: number): Promise<GeneralInformation> {
  const gameInfoMapped = await getMappedGameInfo(matchId);

  return {
    goals: await getScore(matchId),
    fouls: await getFouls(matchId),
    gameInfo: gameInfoMapped,
  };
}
